/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useCallback } from "react";
import styles from "./StepsDots.module.scss";

export interface StepsDotsProps {
  activeStep: number;
}
export const StepsDots = ({ activeStep }: StepsDotsProps) => {
  const renderDots = useCallback(() => {
    return Array.from({ length: activeStep }, (_, index) => (
      <div key={index} className={styles.dot}></div>
    ));
  }, [activeStep]);

  return <div className={styles.dotWrapper}>{renderDots()}</div>;
};
